import ColorScheme from 'color-scheme'

const scheme = new ColorScheme()

export default () => {
  const h = Math.round(Math.random() * (256 ^ 3))
  return scheme.from_hue(h).scheme('monochromatic').variation('hard').colors().map((c) => ('#' + c))
}
